import { render, staticRenderFns } from "./InformeAuditoriaDischargeLocal.vue?vue&type=template&id=dcec6c58&"
import script from "./InformeAuditoriaDischargeLocal.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaDischargeLocal.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaDischargeLocal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VChip,
  VExpansionPanel,
  VExpansionPanelContent,
  VIcon,
  VTextarea,
})
